<template>
  <div class="applicationDiscount">
    <div class="main_width m0a">
      <div class="topper pl36 fStart aifs mt38 mb25">
        <div class="item_logo"></div>
        <!--进度条-->
        <Steps :current="code-1" class="tl fl step_style">
          <Step content="票面试算"></Step>
          <Step content="提交下单"></Step>
          <Step content="完善资料"></Step>
          <Step content="网银操作"></Step>
          <Step content="放款成功" class="stepFinish"></Step>
        </Steps>
      </div>

      <div class="bs2 mb20 pr bgfff br4 ">
        <div v-if="code==1 && stepDetails ===1" class="pt10">
          <p class="c333 tl mt10 ml10 fcenter aic"><span class="dl w5 h14 bge1241a br4 mr10"></span> 请上传票面图片获取试算报价</p>
        </div>
        <div v-else>
          <ticket-info :allParam="allParam" :code="code"></ticket-info>
        </div>
        <!-- 订单取消页 -->
        <div v-if="isCancel" class=" mb20 pr">
          <!-- 买断类 -->
          <div>
            <div v-if="allParam.status === 'CANCEL'">
              <p class="f20 fb tc mb20"> 订单已取消成功 </p>
              <div class="bgFAFAFA dCC mh350 w100b fm bdr10">
                <p class="mt20"><i class="icon-quxiao-chenggong"></i></p>
                <p class="f18 fb c333 tc">订单已取消成功</p>
              </div>
              <div class="tc mt20 pb20">
                <Button type="default" class="bgfff">返回首页</Button>
              </div>
            </div>
            <div v-else>
              <p class="f20 fb tc mb20">正在取消订单 </p>
              <div class="bgFAFAFA dCC mh350 w100b fm bdr10">
                <p class="mt20"><i class="icon-await"></i></p>
                <p class="f18 fb c333 tc">正在取消订单</p>
                <p class="c666 tc mb20">请勿在此期间向机构进行背书</p>
              </div>
              <div class="tc mt20 pb20">
                <Button type="primary" class="w200 mr20" @click="handleCustomerBtn()">联系客服</Button>
                <Button type="default" class="w120 bgfff" @click="orderCancelShow = true">暂不取消</Button>
                <Button type="default" class="w120 ml20 bgfff" @click="reLoad">刷新</Button>
              </div>
            </div>
          </div>

        </div>
        <div v-else-if="isFail" class=" mb20 pr">
          <div class="mh350 p14">
            <p style="text-align: left; padding-left: 14px;" class="f20 fb tc mb20">订单受理失败 </p>

            <div class="bgFAFAFA dCC mh350 w100b fm bdr10">
              <p class="mt20"><i class="icon-fail "></i></p>
              <p class="f18 fb c333 tc">订单受理失败</p>
              <div class="c666 tc mb20 w200">
                <p class="tl" v-if="allParam.rejectReason">失败理由： {{allParam.rejectReason}}</p>
              </div>

            </div>
            <div class="tc mt20">
              <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
              <Button type="primary" class="ml20" v-if="allParam.rejectReason" @click="reloadSubmit">重新提交</Button>
            </div>
          </div>
        </div>

        <div v-else>
          <!-- 票面询价 -->
          <div v-if="code==1" class=" mb20 pr">
            <!-- 票面识别 -->
            <div class="table-content p40  pb70" v-if="stepDetails ==1">
              <div class="df jca mb30">
                <div class="mr40">
                  <div class="c999 f14 mb20 tl">票面图片(正面)</div>

                  <div class="divOcrImg pr">
                    <div class="df fDC aic jcc pr h100b img_left cp" @click="uploadImg">
                      <p class="fb l25 f24 c8FA4C8">商业承兑汇票</p>
                      <p class="fb f16 mt93 c333">点击此处上传票面图片</p>
                      <p class="c6C819B f14 mb30">(网银截图／清晰的照片)</p>

                      <input ref="upload_file" type="file" class="upload-file dn upload_file" @change="getFile($event, 'aupUrlA')">
                    </div>
                    <div class="pa left0 t0 w100b h100b bscontain bimginitial bg000" v-if="allParam.billBase64" :style="{'backgroundImage': 'url(' + allParam.billBase64 + ')'}"></div>

                    <div class="pa t11 r10 zi2" v-if="allParam.billBase64">
                      <Button type="info" class="f14" @click="viewerExampleShow('base64Img')">查看大图</Button>
                      <img ref="base64Img" id="base64Img" style="display:none;" :src="allParam.billBase64">
                      <Button type="primary" class="f14 ml15" @click.stop="uploadImg">更换票面</Button>
                    </div>

                    <div class="pa t13 r13 zi2" v-else>
                      <Button class="f14 w110" type="info" icon="ios-search" @click="viewerExampleShow('exampleImg')">查看示例</Button>
                      <img ref="exampleImg" id="exampleImg" style="display:none;" src="~@/assets/img/businessTicketDiscount/tU_b@2x.png">
                    </div>

                    <div class="ocrLodingAnimateBg" v-if="code1Param.ocrLoading">
                      <div class="ocrLodingAnimate"></div>
                    </div>
                  </div>
                </div>

                <div class="f1">
                  <div class="df jcb mb20">
                    <span class="f14 c999">票面信息</span>
                    <span v-if="code1Param.msgTip" class="f12" :class="[code1Param.msgTipCss]">{{code1Param.msgTip}}</span>
                  </div>
                  <div class="right_ticket_img">
                    <div class="df aic mb30 pr">
                      <span class="dl w76 tl c666 f16">票号</span>
                      <div v-if="code1Param.ocrLoading" class="pr f1">
                        <Input placeholder="识别中" disabled class="f1" />
                        <Icon type="ios-loading" size=15 class="demo-spin-icon-load demo-spin-icon-load-position"></Icon>
                      </div>
                      <Input :class="allParam.billNoTip || allParam.billNoTip2?'error_input':''" v-else-if="allParam.billBase64 || allParam.jump" v-model="allParam.billNo" placeholder="请输入票号" @keyup.native="billNoNumber" @on-blur="blurNoNum" class="f1" maxlength="30" />
                      <Input v-else placeholder="请先上传票面图片，信息将自动识别" disabled class="f1" />
                      <span v-if="allParam.billNoTip" class="" style="position: absolute; top: 34px; left: 76px; color: red;">票号不满30位</span>
                      <span v-if="allParam.billNoTip2" class="" style="position: absolute; top: 34px; left: 76px; color: red;">商票票号不合法</span>
                    </div>
                    <div class="df aic jcb mb30">
                      <div class="w100b df aic pr">
                        <span class="dl w76 tl c666 f16">到期日</span>
                        <div v-if="code1Param.ocrLoading" class="pr f1">
                          <Input placeholder="识别中" disabled class="f1" />
                          <Icon type="ios-loading" size=15 class="demo-spin-icon-load demo-spin-icon-load-position"></Icon>
                        </div>

                        <DatePicker v-model="allParam.dueDate" :editable="false" v-else-if="allParam.billBase64 || allParam.jump" type="date" placement="top-start" placeholder="请选择到期日" class="f1" @on-change="queryDayByDate"></DatePicker>

                        <Input v-else placeholder="请先上传票面图片，信息将自动识别" disabled class="f1" />
                        <span class="dueDayStyle" v-if="allParam.dueDays">{{allParam.dueDays}}</span>
                      </div>
                    </div>
                    <div class="df aic jcb mb30">
                      <div class="w100b df aic pr">
                        <span class="dl w76 tl c666 f16">承兑人</span>
                        <div v-if="code1Param.ocrLoading" class="pr f1">
                          <Input placeholder="识别中" class="f1" />
                          <Icon type="ios-loading" size=15 class="demo-spin-icon-load demo-spin-icon-load-position"></Icon>
                        </div>
                        <Input :class="allParam.acceptorBankNumTip?'error_input':''" v-else-if="allParam.billBase64 || allParam.jump" v-model="allParam.acceptorName" placeholder="请输入承兑人信息" class="f1" />
                        <Input v-else placeholder="请先上传票面图片，信息将自动识别" disabled class="f1" />
                        <!-- <span v-if="allParam.acceptorBankNumTip" class="" style="position: absolute; top: 34px; left: 76px; color: red;">承兑行不满12位</span> -->
                      </div>
                    </div>
                    <div class="df aic jcb mb30">
                      <div class="w100b df aic pr">
                        <span class="dl w76 tl c666 f16">票面金额</span>
                        <div v-if="code1Param.ocrLoading" class="pr f1">
                          <Input placeholder="识别中" disabled class="f1" />
                          <Icon type="ios-loading" size=15 class="demo-spin-icon-load demo-spin-icon-load-position"></Icon>
                        </div>
                        <Input v-else-if="allParam.billBase64 || allParam.jump" v-model="allParam.billAmount" placeholder="请输入票面金额" @keyup.native="billAmountNumber" class="f1" maxlength="12" />
                        <Input v-else placeholder="请先上传票面图片，信息将自动识别" disabled class="f1" />
                        <span v-if="!code1Param.ocrLoading" class="pa r5 c0077DA t5">{{digitUppercase(allParam.billAmount)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Button class="f16 w268 hl45 p0" @click="nextBtnEvent" :disabled="!code1Param.nextStatus" :class="[code1Param.nextStatus ? 'btnDiscountBg' : 'btnDisable']">
                提交试算
              </Button>
            </div>
            <div v-if="stepDetails !==1" class=" ">
              <p style="text-align: left; padding-left: 14px;" class="f20 fb">试算结果 <span class="f14">（以下结果仅为试算，准确价格以下单结果为准）</span> </p>

              <div v-if="stepDetails===2" class="dCC p14 ">
                <div class="bgFAFAFA dCC mh350 w100b f18 fm bdr10">正在向机构查询您的融票报价</div>
              </div>
              <!-- 选择机构 -->
              <div v-else-if="stepDetails===3" class="mh350 p14">
                <div class="bgFAFAFA mh350 w100b bdr10 p14 trialResultList">
                  <ul>
                    <li class="bccc bdr5 mt14 fStart h80 aic f12 " v-for="item in allParam.trialResultData" :key="item.id">
                      <div class=" fStart aic prl ml10">
                        <div class="w46 h46 pl4 bdr50b over-flowH be9e9e9 mr10">
                          <img :src="item.creditChannel.channelLogo" alt="" v-if="item.creditChannel.channelLogo" class="w46 h46">
                        </div>
                        <div class="pr20 tl">
                          <p :class="['f18','fb','mw100',item.status !== 'FAIL'? 'c333': 'c666' ]">{{item.creditChannel.channelName}}</p>
                          <Tooltip v-if="(item.creditChannel.channelDesc && item.creditChannel.channelDesc.length > 8)" :content="item.creditChannel.channelDesc" placement="bottom" max-width="100%" class="tool-tip-s">
                            <p class="c666 w100 tl otw c7f7f7f f13">{{item.creditChannel.channelDesc}}</p>
                          </Tooltip>
                          <p class="c666 mw100" v-else>{{item.creditChannel.channelDesc}}</p>
                        </div>
                      </div>
                      <div class="w1 h38 pl20 blccc "></div>
                      <div class=" plr40 tl">
                        <div>
                          <p class="c666">融票类型</p>
                          <p :class="['f14', 'fb',item.status !== 'FAIL'?'c333': 'c999']">买断</p>
                        </div>
                      </div>
                      <div class="w1 h38  ble9e9e9"></div>
                      <div class="fStart  plr40">
                        <div class="plr40 tl">
                          <p class="c666">年化报价</p>
                          <p :class="['f14', 'fb',item.status !== 'FAIL'?'c333': 'c999']" v-if="item.discountRate">{{Number(item.discountRate).mul(100).toFixed(2)}}%</p>
                          <p v-else :class="['f14','',item.status !== 'FAIL'? 'c333': 'c666' ]"> — </p>
                        </div>
                        <div class="plr40 tl">
                          <p class="c666">每十万</p>
                          <p :class="['f14', 'fb',item.status !== 'FAIL'?'c333': 'c999']" v-if="item.discountMsw">{{item.discountMsw}}</p>
                          <p :class="['f14','',item.status !== 'FAIL'? 'c333': 'c666' ]" v-else> — </p>
                        </div>
                      </div>
                      <div class="w1 h38  ble9e9e9"></div>
                      <div class="fStart ml40 mr20">
                        <div class="plr40 tl">
                          <p class="c666">付息</p>
                          <p :class="['f14', 'fb',item.status !== 'FAIL'?'c333': 'c999']" v-if="item.discountInterest">{{formatMoney(item.discountInterest, 2,'￥')}}</p>
                          <p :class="['f14','',item.status !== 'FAIL'? 'c333': 'c666' ]" v-else> — </p>
                        </div>
                        <div class="plr40 tl">
                          <p class="c666">融票可获金额</p>
                          <p :class="[item.status !== 'FAIL'?'': 'c999']" class="f14 fb cB50000" v-if="item.discountAmount">{{formatMoney(item.discountAmount, 2,'￥')}}</p>
                          <p :class="['f14','',item.status !== 'FAIL'? 'c333': 'c666' ]" v-else> — </p>
                        </div>
                      </div>
                      <div class="fStart">
                        <div>
                          <!-- <Tooltip v-if="item.status === 'FAIL' && item.failReason" :content="item.failReason" placement="top" max-width="100%" class="tool-tip-s">
                            <Button type="default" :class="['bdr25',item.status === 'FAIL'?'disabledStyle':'']" :disabled="item.status === 'FAIL'" @click="checkTrial(item)">
                              暂无授信
                            </Button>
                          </Tooltip> -->
                          <div v-if="item.status === 'FAIL' && item.failReason" class="df jcc fDC">
                            <Button type="default" :class="['bdr25',item.status === 'FAIL'?'disabledStyle':'']" :disabled="item.status === 'FAIL'" @click="checkTrial(item)">
                              暂无授信
                            </Button>
                            <Tooltip v-if="item.status === 'FAIL' && item.failReason" :content="item.failReason" placement="top" max-width="100%" class="tool-tip-s">
                              <p class="w88 otw ce4231d">{{item.failReason}}</p>
                            </Tooltip>
                          </div>
                          <Button v-else type="primary" :class="['bdr25',item.status === 'FAIL'?'disabledStyle':'']" :disabled="item.status === 'FAIL'" @click="checkTrial(item)">
                            立即下单
                          </Button>
                        </div>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>


            </div>

          </div>
          <!-- 提交下单 -->
          <div v-if="code==2" class=" mb20 pr">

            <!-- 申请中 -->
            <div class=" ">
              <div v-if="code2Param.code===1" class="dCC p14 ">
                <p class="f20 fb tc mb20">正在向机构下单 </p>

                <div class="bgFAFAFA dCC mh350 w100b fm bdr10">
                  <p class="mt20"><i class="icon-await "></i></p>
                  <p class="f18 fb c333 tc">正在向机构下单</p>
                  <p class="c666 tc mb20">下单成功后将为您反馈准确报价</p>
                  <table class="bccc mt20">
                    <tr>
                      <td class="brccc w120 h40 bbe9e9e9 tc bgF1F5F8 c333">机构名称</td>
                      <td class="bbe9e9e9 w400 tl pl20">{{allParam.creditChannel.channelDesc}}</td>
                    </tr>
                    <tr>
                      <td class="brccc w120 h40 tc bgF1F5F8 c333">融票类型</td>
                      <td class="w400 tl pl20">{{getCodeType(allParam.discountType) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="tc mt20">
                  <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
                </div>
              </div>

              <!-- 机构已接单，请确认信息 -->
              <div v-if="code2Param.code===2" class="dCC p14 ensureOrder">
                <p class="f20 fb tc mb20">机构已接单，请确认信息 </p>

                <div class="bgFAFAFA fSpace h328 w100b fm bdr10 p14">
                  <div>
                    <table class="bccc c333 bgfff">
                      <tr>
                        <td rowspan="3" class="brccc w80 h40  tc c333">订单信息</td>
                        <td class="brccc w130 h40 bbe9e9e9 tc c666 bgF1F5F8">订单编号</td>
                        <td class="bbe9e9e9 w360 tl pl20">{{allParam.orderNo}}</td>
                      </tr>
                      <tr>
                        <td class="brccc w130 h40 tc c666 bgF1F5F8 bbe9e9e9">报价机构</td>
                        <td class="w40 tl pl20 bbe9e9e9">{{allParam.creditChannel.channelDesc}}</td>
                      </tr>
                      <tr>
                        <td class="brccc w130 h40 tc c666 bgF1F5F8 ">订单类型</td>
                        <td class="w360 tl pl20 ">{{ getCodeType(allParam.discountType)}}</td>
                      </tr>
                    </table>
                    <table class="bccc mt20 c333 bgfff">
                      <tr>
                        <td rowspan="4" class="brccc w80 h40  tc c333">融资人信息</td>
                        <td class="brccc w130 h40 bbe9e9e9 tcc666  bgF1F5F8">名称</td>
                        <td class="bbe9e9e9 w360 tl pl20">{{allParam.acct.corpName}}</td>
                      </tr>
                      <tr>
                        <td class="brccc w130 h40 tc c666 bgF1F5F8 bbe9e9e9">回款账号</td>
                        <td class="w40 tl pl20 bbe9e9e9">{{allParam.acct.acctNo}}</td>
                      </tr>
                      <tr>
                        <td class="brccc w130 h40 tc c666  bgF1F5F8 bbe9e9e9">开户行</td>
                        <td class="w360 tl pl20 bbe9e9e9">{{allParam.acct.branchBankName}}</td>
                      </tr>
                      <tr>
                        <td class="brccc w130 h40 tc c666 bgF1F5F8 ">开户行号</td>
                        <td class="w360 tl pl20 ">{{allParam.acct.branchBankNo}}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="bccc  pl16 pr16 pt10 w47b left bgfff">
                    <div class="top  w100b">
                      <p class="f16 c333 tl bbccc ">融票价</p>
                      <div class="mt10 ">
                        <div class="fSpace h70 cB50000 ">
                          <div class="cFFD7D5 w48b fSpace aic br4">
                            <div class="bdr50b w40 h40 bgfff dCC ml14 f12 cE1241A">年化</div>
                            <p class="mr16 f16  fb cB50000">{{Number(allParam.discountRate).mul(100).toFixed(2)}}%</p>
                          </div>
                          <div class="cFFD7D5 w48b fSpace aic br4">
                            <div class="bdr50b w40 h40 bgfff dCC ml14 f12">每十万</div>
                            <p class="mr16 f16 fb cB50000">{{formatMoney(allParam.discountMsw, 2, '')}}元</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="bottom mt20 c666">
                      <p class="tl">可收款明细：</p>
                      <div class="bgFAFAFA p14 br4">
                        <p class="fSpace"><span>票面金额</span> <span class="fb c333">{{formatMoney(allParam.billAmount, 2, '')}}元</span> </p>
                        <p class="fSpace bbccc pb8"><span>总付息</span> <span class="fb c333">- {{formatMoney(allParam.discountInterest, 2, '')}}元</span> </p>
                        <p class="fSpace pt8"><span>融票可得</span> <span class="cB50000 fb">= {{formatMoney(allParam.discountAmount, 2, '')}}元</span> </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tc mt20">
                  <Button type="primary" class="mr20" @click="nextBtnEvent">确认，开始上传资料</Button>
                  <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
                </div>
              </div>

            </div>

          </div>

          <!-- 完善资料 -->
          <div v-if="code==3" class=" mb20 pr">

            <!--  -->
            <div class="improveData">
              <div v-if="code3Param.code===1">
                <!-- 京东秒融 资料上传 -->
                <improveDataJdMR v-if="code3Param.creditChannel==='JDMR'"></improveDataJdMR>
              </div>


              <div v-if="code3Param.code===2" class="dCC p14 pr">
                <p class="f20 fb tc mb20">贸易背景资料审核中 </p>
                <div class="bgFAFAFA dCC mh350 w100b fm bdr10">
                  <p class="mt20"><i class="icon-await "></i></p>
                  <p class="f18 fb c333 tc">贸易背景资料审核中</p>
                  <p class="c666 tc mb20">请耐心等待资料审核，如有疑问请联系客服</p>

                </div>
                <div class="tc mt20">
                  <Button type="primary" class="w200 mr20" @click="handleCustomerBtn()">联系客服</Button>
                  <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
                  <Button type="default" class="w80 ml20 bgfff" @click="reLoad">刷新</Button>
                </div>
              </div>

            </div>

          </div>

          <!-- 网银操作 -->
          <div v-if="code==4" class=" mb20 pr">

            <!-- 买断类资金方 -->
            <div class="dCC p14 pr" v-if="code4.code === 1">
              <p class="f20 fb tc mb20">请操作网银进行背书 </p>
              <div class=" bgFAFAFA w100b mh350">
                <p class="f20 fb tc mt20 mb20 c333"><span class="f20 cB50000 ">*</span>请严格按照以下路径进行背书</p>
                <div class="fRowCenter">
                  <div class="kapian kapian_a">
                    <div class="p14 h76">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">背出账户</span>
                      </div>
                      <p class="f16 fm">{{allParam.acct.corpName}}</p>
                    </div>
                    <div class="p14">
                      <div class="df aibl">
                        <span class="title">账号</span>
                        <p class="w280">{{allParam.acct.acctNo || ''}}</p>
                      </div>
                      <div class="df aibl mt10 mb10">
                        <p class="title ">开户行</p>
                        <p class="w280">{{allParam.acct.branchBankName || ''}}</p>
                      </div>
                      <div class="df aibl ">
                        <p class="title ">行号</p>
                        <p class="w280">{{allParam.acct.branchBankNo || ''}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="fW aic ml30 mr30">
                    <div>
                      <p><img src="~@/assets/img/businessTicketDiscount/icon_bsz.png" alt=""></p>
                      <p class="mt14">背书至</p>
                    </div>

                  </div>
                  <div class="kapian kapian_b">
                    <div class="p14 h76">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">资金方签收账户</span>

                      </div>
                      <p class="f16 fm">{{allParam.orderJd.signAcctName || ''}}</p>
                    </div>
                    <div class="p14">
                      <div class="df aibl">
                        <span class="title">账号</span>
                        <p class="w280">{{allParam.orderJd.signAcctNo || ''}}</p>
                      </div>
                      <div class="df aibl mt10 mb10">
                        <span class="title ">开户行</span>
                        <p class="w280">{{allParam.orderJd.signAcctBankName || ''}}</p>
                      </div>
                      <div class="df aibl">
                        <span class="title ">行号</span>
                        <p class="w280">{{allParam.orderJd.signAcctBankNo || ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div class="tc mt20">
                <Button type="primary" class="w200 mr20" @click="endorse()">已完成背书</Button>
                <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
              </div>
            </div>
            <!-- 银行类资金方 -->
            <!-- <div v-if="stepDetails===10" class="dCC p14 pr">
              <p class="f20 fb tc mb40">请操作网银进行贴现 </p>
              <div class=" bgFAFAFA w100b mh350">
                <p class="f20 fb tc mt20 mb20 c333"><span class="f20 cB50000 ">*</span>请严格按照以下路径进行背书</p>
                <div class="fRowCenter">
                  <div class="kapian kapian_a mr20">
                    <div class="p14 h76">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">资金方签收账户</span>
                      </div>
                      <p class="f16 fm">{{'上海豆伴互联网金融信息服务有限公司'}}</p>
                    </div>
                    <div class="p14">
                      <p><span class="title">账号</span>1232132131231312312312312313123</p>
                      <p><span class="title mt10 mb10">开户行</span></p>
                      <p><span class="title">行号</span></p>
                    </div>
                  </div>
                  <div class="kapian kapian_b">
                    <div class="p14 h76">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">贴现信息</span>
                      </div>
                      <p class="f16 fm">贴入行：{{'上海豆伴互联网金融信息服务有限公司'}}</p>
                    </div>
                    <div class="p14">
                      <p><span class="title">贴入行账号</span>12321321312313123123<span class=" ml20 btnCopy cp bgfff c333 br25 dl pt2 pb2 w56  tc" :data-clipboard-text="'222'"> <i class="icon_Copy"></i> 复制</span></p>
                      <p><span class="title mt10 mb10">清算方式</span><span class=" ml20 btnCopy cp bgfff c333 br25 dl pt2 pb2 w56  tc" :data-clipboard-text="'222'"> <i class="icon_Copy"></i> 复制</span></p>
                      <p><span class="title ">贴入利率</span><span class=" ml20 btnCopy cp bgfff c333 br25 dl pt2 pb2 w56  tc" :data-clipboard-text="'222'"> <i class="icon_Copy"></i> 复制</span></p>
                    </div>
                  </div>
                </div>


              </div>
              <div class="tc mt20">
                <Button type="primary" class="w200 mr20" @click="handleCustomerBtn()">联系客服</Button>
                <Button type="default" class="w152 bgfff" @click="orderCancelShow = true">取消订单</Button>
              </div>
            </div> -->
            <div v-if="code4.code === 2" class="dCC p14 pr">
              <p class="f20 fb tc mb20 fcenter"><i class="icon_Clock mr10"></i> 请等待机构回款 </p>
              <div class=" bgFAFAFA w100b mh350">
                <p class="f20 fb tc mt20 mb20 c333">回款金额：<span class="f20 cB50000 fb ">{{formatMoney(allParam.discountAmount, 2,'')}}元</span></p>
                <div class="fRowCenter">
                  <div class="kapian kapian_a mr20">
                    <div class="p14 h76 ">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">回款至</span>
                      </div>
                      <p class="f16 fm">{{allParam.acct.corpName}}</p>
                    </div>
                    <div class="p14">
                      <div class="df aibl">
                        <span class="title">账号</span>
                        <p class="w280">{{allParam.acct.acctNo || ''}}</p>
                      </div>
                      <div class="df aibl mt10 mb10">
                        <p class="title ">开户行</p>
                        <p class="w280">{{allParam.acct.branchBankName || ''}}</p>
                      </div>
                      <div class="df aibl ">
                        <p class="title ">行号</p>
                        <p class="w280">{{allParam.acct.branchBankNo || ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div class="tc mt20">
                <Button type="default" class="w80 bgfff" @click="reLoad">刷新</Button>
              </div>
            </div>
          </div>
          <!-- 放款成功-->
          <div v-if="code==5" class=" mb20 pr">
            <div class="dCC p14 pr">
              <p class="f20 fb tc mb20 fcenter"><i class="icon_hkcg mr10"></i> 回款成功，订单完成 </p>
              <div class=" bgFAFAFA w100b mh350">
                <p class="f20 fb tc mt20 mb20 c333">回款金额：<span class="f20 cB50000 fb ">{{formatMoney(allParam.discountAmount, 2,'')}}</span></p>
                <div class="fRowCenter">
                  <div class="kapian kapian_a mr20">
                    <div class="p14 ">
                      <div class="mb10">
                        <span class="dl bgfff w100 c8785FF br2 l22 h22  tc f12">回款至</span>
                      </div>
                      <p class="f16 fm">{{allParam.acct.corpName}}</p>
                    </div>
                    <div class="p14">
                      <div class="df aibl">
                        <span class="title">账号</span>
                        <p class="w280">{{allParam.acct.acctNo || ''}}</p>
                      </div>
                      <div class="df aibl mt10 mb10">
                        <p class="title ">开户行</p>
                        <p class="w280">{{allParam.acct.branchBankName || ''}}</p>
                      </div>
                      <div class="df aibl ">
                        <p class="title ">行号</p>
                        <p class="w280">{{allParam.acct.branchBankNo || ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tc mt20">
                <Button type="default" class="w120 mr20 bgfff" @click="reUpload">关闭</Button>
                <Button type="primary" class="w200" @click="toLink">进入订单中心</Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 账户选择弹窗 -->
      <Modal v-model="accountShow" width="770" class="header-dn accountShow" :footer-hide="true" :mask-closable="false" @on-cancel="accountShowCancel">
        <div class="accountShow-outter">
          <div class="accountShow-title tc f18 c333 fb bbe9e9e9 pb10">请选择您的收款账户</div>
          <div class="accountShow-content pt40 mh400">
            <div class="tc f14 c666 mb40">您的收款户必须为【票据所在账户】，请准确选择</div>
            <div class="fW jcc ">
              <div class="df w80b aic mb40">
                <span class="c333">公司名称</span>
                <!-- <select placeholder="点击此处选择公司名称" class="w500 ml20 bccc h40 bdr5" v-model="code1Param.discountAcctDto.id" @change="acctEvent">
                  <option v-for="item in code1Param.cpDiscountActt" :value="item.id" :key="item.id" :disabled="item.isNoOpenCp">
                    <div class="fSpace" v-if="item.isNoOpenCp">
                      <span>{{item.corpName}}</span>
                      <span @click="openAcct" class="cE1241A cursorP f12">未开通商票业务</span>
                    </div>
                    <span v-else>{{item.corpName}}</span>
                  </option>
                </select> -->
                <Select placeholder="点击此处选择公司名称" class="w500 ml20" @on-change="acctEvent">
                  <Option v-for="item in code1Param.cpDiscountActt" :value="item.id" :key="item.id" :disabled="item.isNoOpenCp">
                    <div class="fSpace" v-if="item.isNoOpenCp">
                      <span>{{item.corpName}}</span>
                      <span @click="openAcct" class="cE1241A cursorP f12">未开通商票业务</span>
                    </div>
                    <span v-else>{{item.corpName}}</span>
                  </Option>
                </Select>
              </div>
              <div class="df w80b aic mb50">
                <span class="c333">网银账户</span>
                <Select placeholder="点击此处选择账号" class="w500 ml20" :disabled="true" v-model="code1Param.discountAcctDto.acctId">
                  <Option :value="code1Param.discountAcctDto.acctId" key="2">{{code1Param.discountAcctDto.acctId}}</Option>
                </Select>
              </div>
            </div>
          </div>
          <div class="accountShow-bottom tc">
            <Button type="primary" @click="applyOrder" class="w210" :disabled="!code1Param.discountAcctDto.acctId">确认</Button>
          </div>
        </div>
      </Modal>
      <!-- 订单取消页面 -->
      <Modal v-model="orderCancelShow" width="770" class="header-dn accountShow" :footer-hide="true" :mask-closable="false">
        <div class="accountShow-title tc f18 c333 fb bbe9e9e9 pb10">提示</div>
        <div class="h300 dCC">
          <i class="icon-quxiao"></i>
          <p class="c333 f18 fm" v-if="!isCancel">是否取消本次订单？</p>
          <p class="c333 f18 fm" v-else>是否取消本次申请？</p>
        </div>
        <div>
          <div class="fRowCenter" v-if="isCancel">
            <Button type="primary" class="w200" @click="orderCancelShow = false">暂不取消</Button>
            <Button type="default " class="w120 ml20 bgfff" @click="cancelOrderConfirm">确认取消</Button>
          </div>
          <div class="fRowCenter" v-else>
            <Button type="primary" class="w200" @click="orderCancelShow = false">暂不取消</Button>
            <Button type="default" class="w120 ml20 bgfff" @click="cancelOrderApply">确认取消</Button>
          </div>

        </div>
      </Modal>
    </div>
  </div>
</template>


<script>
import ticketInfo from "./ticketInfo.vue";
import store from '@/store/store';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import imgUpload from '@/components/module/imgUpload'
import improveDataJdMR from './component/improveDataJdMR.vue'

var _this = "";

window.hidePopus = function () {
  store.state.showPopups = false;
}

export default {
  store, // 引用
  name: "homeMenu",
  components: {
    ticketInfo,
    imgUpload,
    improveDataJdMR
  },
  provide () {
    return {
      parentsData: this
    }

  },
  data () {
    return {
      code: 1, // 步骤
      stepDetails: 1, // 步骤
      accountShow: false, // 账户选择弹窗
      orderCancelShow: false,
      isCancel: false,// 取消状态
      isFail: false,// 失败状态

      allParam: {
        userId: this.$store.state.userId, // 用户id

        ocrTimer: '',

        billBase64: '', // 上传票面的base64格式
        billPic: "", // 票据图片

        jump: '', // 是否是从银票跳转到商票的

        billNo: '', // 票号
        billNoTip: false, // 票号提示
        billNoTip2: false,  // 票号开头提示
        billAmount: '', // 票面金额
        billAmountSupper: "", // 票面金额-大写

        acceptorBankNumTip: false, // 承兑行行号提示
        acceptorName: "", // 承兑人名称
        acceptorBankNum: "", // 承兑人开户账号

        drawer: '',   // 出票人名称
        dueDate: "", // 到期日期，格式：yyyy-MM-dd
        dueDays: "", // 到期天数

        discountAmount: '', // 出票可得金额 试算后的订单信息
        discountRate: '', // 年化利率 试算后的订单信息
        orderNo: '', // 订单编号 试算后的订单信息
        channelDesc: '', // 订单编号 试算后的订单信息
        channelDesc: '', // 报价机构 试算后的订单信息
        discountType: '', // 订单类型 试算后的订单信息
        discountInterest: '', // 利息 试算后的订单信息
        acct: {}, //// 订单类型 试算后的订单信息
        orderJd: {}, // 京东独有

        // 选择的账户信息
        discountAcctDto: {
          id: '',
          accId: ''
        },
        trialResultData: [], // 试算结果列表
        trial: {
          id: ''
        } // 选中的试算机构
      },

      code1Param: {
        nextStatus: false, // 是否可以点击下一步

        msgTip: '', // 提示
        msgTipCss: '', // 提示的样式

        ocrLoading: false,  // ocr识别loading
        canDiscountAcct: [],
        cpDiscountActt: [],
        discountAcctDto: {
          id: '',
          acctId: ''
        }
      },
      code2Param: {
        code: 1, // 当前节点的小节点
        nextStatus: false, // 是否可以点击下一步

        msgTip: '', // 提示
        msgTipCss: '', // 提示的样式

        ocrLoading: false,  // ocr识别loading
        canDiscountAcct: [],
        cpDiscountActt: [],
        discountAcctDto: {
          id: '',
          acctId: ''
        }
      },

      code3Param: {
        code: 1,// 当前节点 小节点
        creditChannel: '',// 报价机构
        // 背书上传
        endorse: [{ filename: '', file: '', loading: false }],

        contract: [{ filename: '', file: '', loading: false }],

        invoice: [{ filename: '', file: '', loading: false }],

        settlement: [{ filename: '', file: '', loading: false }],

        other: [{ filename: '', file: '', loading: false }]
      },
      code4: {
        code: 1
      },

      code3Sum: 0,

      requestData: {},
      timer: null, // 轮询定时器

    }
  },
  // 监听
  watch: {
    allParam: {
      handler: function (nval) {
        this.allParam.userId = this.$store.state.userId;

        if (this.allParam.billNo &&
          this.allParam.billAmount &&
          this.allParam.acceptorName &&
          this.allParam.dueDate) {

          this.code1Param.nextStatus = true;
        } else {
          this.code1Param.nextStatus = false;
        }
      },
      deep: true,
    },
  },
  created () {
    _this = this;
    console.log(this.$route.params.id);
    // 页面跳转传递参数
    if (this.$route.params.id) {
      this.addLoading()
      this.getDetail(this.$route.params.id)
    }
    this.initBtnCopy()
  },
  beforeRouteEnter (to, from, next) {
    next();

    // 如果不是从开户进入则忽略
    if (from.name == 'OpenBizAccount') {
      console.log('商票路由', to, from);

      if (from.query.id) {
        from.query.id ? _this.getDetail(from.query.id) : '';
      }
    }
  },
  beforeDestroy () {
    clearTimeout(_this.timer)
  },
  methods: {
    // 数据处理
    // true-整数
    handleNumber (str, isNum) {
      return isNum ? str.replace(/[^\d.]/g, '').replace('.', '') : str.replace(/[^\d.]/g, '');
    },
    billNoNumber () {
      this.allParam.billNo = this.handleNumber(this.allParam.billNo, true);
    },
    billAmountNumber () {
      this.allParam.billAmount = this.handleNumber(this.allParam.billAmount);
    },
    acceptorBankNumNumber () {
      this.allParam.acceptorBankNum = this.handleNumber(this.allParam.acceptorBankNum, true);
    },

    // 优化对象赋值
    handleObj (arr, obj) {
      let newObj = {}

      arr.forEach((val) => {
        newObj[val] = obj[val] || '';
      })
      return newObj;
    },

    // 票据信息清空
    handleBill () {
      _this.allParam.ocrTimer ? clearTimeout(_this.allParam.ocrTimer) : '';
      Object.assign(_this.allParam, this.handleObj(['billNo', 'billAmount', 'billAmountSupper', 'acceptorName', 'drawer', 'dueDate', 'dueDays'], {}));
    },

    // 查看示例图 && 大图
    viewerExampleShow (name) {
      const viewerData = {}

      viewerData['viewer' + name] = new Viewer(document.getElementById(name), {
        title: false,    // 显示图片标题
        tooltip: false,  // 显示缩放比例
        hidden: function () {
          viewerData['viewer' + name].destroy();
        }
      });

      this.$refs[name].click();
    },

    // 初始化复制按钮
    initBtnCopy () {
      let _this = this
      _this.myClipboard ? _this.myClipboard.destroy() : '';
      this.myClipboard = new this.clipboard('.btnCopy');
      this.myClipboard.on('success', function (e) {
        _this.$Message.success("复制成功!");

        // 先销毁之前的，再重新定义
        _this.myClipboard.destroy();
        _this.initBtnCopy();

        e.clearSelection();
      });
      this.myClipboard.on('error', function (e) {
        _this.$Message.info('请按 Ctrl+C 复制文字');
      });
    },



    //======== 步骤 1 start ===========//
    // 图片处理
    // 上传票面
    uploadImg () {
      // this.$refs[name].dispatchEvent(new MouseEvent('click')); // IE中有兼容性问题
      this.$refs.upload_file.click();
    },

    // 处理图片
    getFile (e, param) {
      if (_this.code1Param.priceFail) {
        _this.code1Param.priceFail = false;
      }

      this.imgToBase64(e, function (base, fileTarget) {
        // console.log(base, "base处理图片");
        _this.ossUpload(fileTarget, (data) => {
          console.log('====== oss =========', data);
          // _this.removeLoading();
          // _this.setArrayVal(paramList, data.url);
          // _this.setArrayVal(`agreementData.${clearname}`.split('.'), '');
          // _this.setArrayVal(`${param}Loading`.split('.'), false);
          // _this.uploadNum--;
          _this.allParam.billBase64 = data.url;
          _this.allParam.billNoTip = false;
          _this.allParam.billNoTip2 = false;
          _this.allParam.acceptorBankNumTip = false;

          _this.ocrDiscern();  // 进行OCR识别

          _this.allParam.ocrTimer ? clearTimeout(_this.allParam.ocrTimer) : '';
          _this.allParam.ocrTimer = setTimeout(function () {
            _this.handleBill();  // 票据信息清空
            _this.code1Param.ocrLoading = false;
            _this.code1Param.msgTip = "未识别到任何承兑汇票信息，请重新上传票面或手动填写";
            _this.code1Param.msgTipCss = "dp-c-fail";
          }, 30000)
        })
        // _this.allParam.billBase64 = base;


      });
    },
    imgUploadChange (emeit, url) {
      console.log(emeit, url);
    },

    // OCR识别
    ocrDiscern () {
      // this.addLoading();
      this.code1Param.ocrLoading = true;
      this.code1Param.nextStatus = false;  // 下一步标识关闭
      this.allParam.dueDate = ''; // 删除到期日
      this.sendOther({
        url: '/web/bill/ocrRecognize',
        data: { base64: this.allParam.billBase64 },
        tip: false,
        successCallback: (result) => {
          this.hasOwnProperty('loading') ? this.loading = true : "";

          console.log("ack回调", result);
          if (this.code1Param.ocrLoading) {
            _this.allParam.ocrTimer ? clearTimeout(_this.allParam.ocrTimer) : '';
            this.code1Param.ocrLoading = false;

            console.warn('临时将开票行名称和承兑行名称赋值');
            const successData = result.data.data
            if (successData) {
              Object.assign(_this.allParam, {
                billNo: successData.acceptDraftId || '', // 票据号码
                billAmount: successData.parMoney || '', // 票面金额
                acceptorName: successData.acceptorName || '', // 承兑人名称
                acceptorBankNum: successData.acceptorAccount || '', // 承兑人开户账号
                drawer: successData.drawerName || '',   // 出票人名称
                dueDays: successData.maturityDate || '', // 到期天数
                dueDate: successData.draftDueDate || '',
              })
            }

            if (result.data.message) {
              this.$Message.warning(result.data.message);
              this.code1Param.msgTip = "承兑汇票信息识别成功，如有错误请手动修改";
              this.code1Param.msgTipCss = "dp-c-success";
            }
          }
        },
        errCallback: (result) => {
          this.ocrDiscernFail();
        },
        failCallback: (result) => {
          this.ocrDiscernFail();
        }
      })
    },
    // ocr识别失败
    ocrDiscernFail () {
      if (this.code1Param.ocrLoading) {
        this.handleBill();  // 票据信息清空
        this.code1Param.ocrLoading = false;
        this.code1Param.msgTip = "未识别到任何承兑汇票信息，请重新上传票面或手动填写";
        this.code1Param.msgTipCss = "dp-c-fail";
      }
    },

    // 根据到期日查询计息天数
    queryDayByDate: function (data) {
      this.allParam.dueDays = "";
      this.allParam.dueDate = new Date(this.compatibilityIEDate(data)).pattern('yyyy-MM-dd');

      this.sendGet({
        url: '/web/bill/getDueDays',
        data: { dueDate: this.allParam.dueDate },
        tip: false, // false-显示loading, true-隐藏loading
        successCallback (result) {
          _this.allParam.dueDays = result.data.data;
        }
      })
    },

    // 票号 blur
    blurNoNum () {
      // console.log(this.allParam.billNo, 'this.allParam.billNoNumber');
      _this.allParam.billNoTip = _this.allParam.billNo.length != 30 ? true : false;

      // _this.allParam.billNoTip2 = _this.allParam.billNo.length == 30 && _this.allParam.billNo.split('')[0] != 2 ? true : false;
    },

    // 承兑行 blur
    blurBank: function (type) {
      if (this.allParam.acceptorBankNum.length != 12) {
        this.allParam.acceptorBankNumTip = true;
        return false;
      }
      this.allParam.acceptorBankNumTip = false;

      this.sendGet({
        url: '/web/bill/getacceptor',
        data: { acceptorBankNum: this.allParam.acceptorBankNum },
        tip: false // false-显示loading, true-隐藏loading
      }, (result) => {
        this.allParam.acceptorName = result.data.data;
      })
    },
    //======== 步骤 1 end ===========//

    //======== 步骤 2 start ===========//
    // 获取账户
    getAcct () {
      this.sendGet({
        url: '/trade-center/discount-acct/personal/cp?sidx=createTime&sord=desc',
        successCallback: (result) => {
          console.log(result)
          this.code1Param.canDiscountAcct = result.data.data;
        }
      })
    },
    accountShowCancel () {
      // this.code1Param.discountAcctDto.id = ''
      // this.code1Param.discountAcctDto.acctId = ''
    },
    // 选择试算机构
    checkTrial (e) {
      this.allParam.trial = e

      let trial = this.allParam.trial.creditChannel
      let list = this.code1Param.canDiscountAcct
      let arr = []

      list.map(item => {
        if (item.status === 'SUCCESS' && item.cpList && item.cpList.length > 0) {
          const arrCP = item.cpList.filter(e => e.channelCode === trial.channelCode && e.discountChannel === trial.discountChannel);
          if (arrCP.length > 0) {
            if (arrCP[0].status !== 'CREDIT_SUCCESS') {
              arr.push({ ...item, ...{ isNoOpenCp: true } })
            } else {
              arr.push(item)
            }
          }
        }
      })
      this.code1Param.cpDiscountActt = arr
      this.accountShow = true
      // console.log('----this.code1Param.discountAcctDto', this.code1Param.discountAcctDto);
    },
    // 选择公司
    acctEvent (id) {
      this.code1Param.discountAcctDto.id = id
      let acct = this.code1Param.cpDiscountActt.filter(item => item.id == id)[0]
      this.allParam.discountAcctDto.id = id;
      this.allParam.discountAcctDto.accId = `${acct.branchBankNo}` + '' + `${acct.branchBankName}`;
      this.code1Param.discountAcctDto.acctId = `${acct.branchBankNo}` + ' ' + `（${acct.branchBankName}）`;
      console.log('selectChange----------', id, this.code1Param.discountAcctDto, this.allParam.discountAcctDto.accId);
    },

    // 选择账户
    acctChildEvent (child) {
      _this.allParam.discountAcctDto.acctId = child.id;
    },

    // 开通账户
    openAcct () {
      _this.agentEvent({
        success () {
          _this.$router.push({ name: "OpenBizAccount", query: { id: _this.allParam.id } });
        },
        other () {
          _this.$router.push({ name: 'OpenBizAccount', query: { id: _this.allParam.id } }); // 路由跳转传递参数
        }
      });
    },

    // 获取详情
    getDetail (id) {
      let _this = this
      this.sendGet({
        url: `/trade-center/cp-discount-order/${id}`,
        successCallback (result) {
          let resultData = result.data.data;
          _this.removeLoading();
          if (resultData) {
            Object.assign(_this.allParam, resultData);
            _this.allParam.dueDays = _this.allParam.dueDays + '天'
            // console.log('-----getDetail', _this.allParam, resultData);
            _this.synchronization()

            if (resultData.status === 'PROCESS') {
              switch (resultData.node) {
                case 'SUBMIT_DATA':
                  console.log(resultData.applyCancelTime);
                  // 待提交资料
                  _this.code = 3
                  _this.code3Param.code = 1
                  _this.code3Param.creditChannel = resultData.creditChannel.channelCode
                  break;
                case 'DATA_ENTERING':
                  // 待审核 资料核录中
                  _this.code = 3
                  _this.code3Param.code = 2
                  break;
                case 'AUDIT':
                  // 待审核
                  _this.code = 3
                  _this.code3Param.code = 2
                  // _this.code4Param.code = 1
                  break;
                case 'ENDORSE':
                  // 待背书
                  _this.code = 4
                  _this.code4.code = 1
                  break;
                case 'ENDORSE_ENTERING':
                case 'SIGN_AUDIT':
                  // 背书核录中
                  _this.code = 4
                  _this.code4.code = 2
                  break;
                case 'REJECT':
                  // 已驳回
                  _this.code = 3
                  _this.isFail = true
                  break;
              }

              // 申请取消
              if (resultData.applyCancelTime && resultData.cancelReason) {
                _this.isCancel = true
                return
              } else {
                _this.isCancel = false
              }
            } else if (resultData.status === 'SUCCESS') {
              _this.code = 5
            } else if (resultData.status === 'CANCEL') {
              console.log('-----');
              _this.isCancel = true

            }
          }
        }
      })
    },

    // 下一步按钮
    nextBtnEvent () {
      console.log("当前code", this.code, '，数据', this);

      switch (this.code) {
        case 1:
          this.addLoading();

          // 判断当前用户是否登录
          if (!this.fungetLogin()) {
            _this.$Message.error('请先登录，再开始询价');
            this.showLoginPopus();
            this.removeLoading();
            break;
          }

          // 判断信息是否补全
          if (this.allParam.billNo.length != 30) {
            _this.$Message.error('请先补全信息');

            _this.allParam.billNoTip = true;

            this.allParam.acceptorBankNum.length != 12 ? _this.allParam.acceptorBankNumTip = true : _this.allParam.acceptorBankNumTip = false;
            this.removeLoading();
            break;
          }

          if (!this.allParam.billBase64) {
            _this.$Message.error('请先上传票面');
            this.removeLoading();
            break;
          }

          // 银票|商票票号判断调整
          if (this.allParam.billNo.split('')[0] == '1') {
            this.removeLoading();

            this.showTip({
              title: "提示",
              tipClass: 'w770 mb85',
              tipMessage: `<p class="f24 fb l25 mb20">检测到您上传的票据为银票，是否前往银票快贴</p>`, // 提示信息
              tipLogo: "tip_prompt mt96 mb20", // 提示logo

              tipButtonLeft: '是，立即前往',                    // 左按钮名称
              tipButtonLeftType: 'primary',         // 左按钮的类型
              tipButtonLeftCall: function () {
                // 将承兑人、票号、票面金额、到期人 信息带入了到另一个板块
                let toYPData = Object.assign({}, _this.handleObj(['billBase64', 'billNo', 'billAmount', 'acceptorName', 'dueDate', 'dueDays'], _this.allParam));

                _this.$router.push({
                  name: 'ApplicationDiscount',
                  query: toYPData
                });

                _this.hidePopus();
              },    // 左按钮回调

              tipButtonRight: '否，暂不需要',                   // 右按钮名称
              tipButtonRightType: 'default',        // 右按钮类型
              tipButtonRightClass: '',              // 右按钮类名
              tipButtonRightCall: function () {
                _this.hidePopus();
              },   // 右按钮回调
            })

            break;
          }

          if (this.allParam.billNo.split('')[0] != '2') {
            _this.$Message.error('票号不合法');

            _this.allParam.billNoTip2 = true
            this.removeLoading();
            break;
          }

          // 上传图片
          let promise1 = (resolve, reject) => {
            console.log('___________________this.allParam.billBase64', this.allParam.billBase64);
            _this.allParam.billPic = this.allParam.billBase64
            resolve();
          }

          // 询价下单
          let promise2 = (resolve, reject) => {
            this.stepDetails = 2
            console.log('------------', _this.allParam)
            let enquriyData = Object.assign({}, _this.handleObj(['billPic', 'billNo', 'billAmount', 'dueDate', 'acceptorName'], _this.allParam));

            enquriyData.dueDate = new Date(this.compatibilityIEDate(enquriyData.dueDate)).pattern('yyyy-MM-dd');
            enquriyData.billAmount = enquriyData.billAmount.toString();

            // 测试使用
            // enquriyData.acceptorName = '银企直连普通测试67';
            // enquriyData.billAmount = '500';
            console.log('请求接口enquriyData请求数据', enquriyData);

            _this.sendOther({
              url: '/trade-center/cp-discount-trial/trial',
              data: { trial: enquriyData },
              tip: false,
              successCallback: (result) => {
                resolve(result.data.data);
                console.log(result.data.data);
              },
              errCallback: (result) => {
                reject(result);
              }
            })
          }

          // 获取账户列表
          let promise3 = () => {
            this.getAcct()
          }

          new Promise(promise1).then(() => {
            return new Promise(promise2);   // 上传图片完毕，开始询价下单
          }).then(
            (val) => {
              console.log('询价完毕', val, _this.allParam);

              Object.assign(_this.allParam, { trialResultData: val });   // 赋值接口返回数据
              _this.stepDetails = 3
              return new Promise(promise3);   // 询价完毕，获取账户列表
            },

            (res) => {
              console.log('询价完毕，暂无授信', res);

              this.showTip({
                title: "提示",
                tipClass: 'w770 mb85',
                tipMessage: `<p class="f24 fb l25 mb20">${res.data.message}<br/>我们的客服将与您进行联络</p><p class="f14 l15 mb30">请您耐心等待<br/>保持手机畅通</p><span class="dl w80 hl34 bCBCBCB br4 cp btnhcE1241A" onclick="hidePopus()">我知道了</span>`, // 提示信息
                tipLogo: "tip_prompt mt96 mb20", // 提示logo
              })
            }
          );
          break;

        case 2:
          _this.reLoad()
          break;

        case 3:
          this.addLoading();
          if (_this.code3Sum) {
            console.log('等待上传完毕', this.code3Sum)
            setTimeout(() => {
              _this.nextBtnEvent();
            }, 500)
          }

          if (this.code3Sum == 0) {
            this.sendPut({
              url: `/web/bizbill-fin-order/${_this.allParam.id}`,
              data: {
                orderOptType: 'COMPLETE_DATA',
                files: _this.requestData,
              },
              successCallback () {
                _this.code = 4; // 数据处理完成
              },
            })
          }
          break;
      }
    },
    // 刷新
    reLoad () {
      this.addLoading();
      this.getDetail(this.allParam.id)
    },

    // 重新上传票面 || 回到第一步 || 返回按钮 || 取消贴现按钮
    reUpload () {
      this.handleBill(); // 票据信息清空
      Object.assign(this.allParam, this.handleObj(['billPic', 'billBase64'], {}));
      this.allParam.billNoTip = false;
      this.allParam.billNoTip2 = false;
      this.isCancel = false
      this.isFail = false
      Object.assign(this.code1Param, this.handleObj(['msgTip', 'msgTipCss'], {}));
      // console.log('取消贴现按钮', this.allParam)
      this.code = 1;
      this.stepDetails = 1
      this.current = 1;
    },

    // 下单
    applyOrder () {
      this.addLoading();
      let allParam = this.allParam
      let params = {
        user: {
          id: allParam.userId
        },
        trial: {
          id: allParam.trial.id
        },
        acct: {
          id: allParam.discountAcctDto.id
        },
      }
      this.sendOther({
        url: '/trade-center/cp-discount-order/apply-order',
        data: params,
        successCallback: (result) => {
          this.removeLoading();
          // console.log(result, _this.allParam, this.allParam);
          _this.accountShow = false

          Object.assign(_this.allParam, result.data.data);

          // 过渡页
          this.code = 2
          this.code2Param.code = 1

          this.sendGet({
            url: `/trade-center/cp-discount-order/${result.data.data.id}`,
            successCallback (result) {
              let resultData = result.data.data;
              Object.assign(_this.allParam, resultData);
              _this.allParam.dueDays = _this.allParam.dueDays + '天'


              setTimeout(() => {
                _this.code = 2
                _this.code2Param.code = 2
              }, 2000)

            }
          })
        }
      })
    },
    // 机构渠道code
    getCodeType (code) {
      if (code) {
        switch (code) {
          case 'MD':
            return '买断';
          default:
            return code;
        }
      } else {
        return '-'
      }

    },
    // 重新提交资料
    reloadSubmit () {
      _this.isFail = false
      _this.code = 3
      _this.code3Param.code = 1
      _this.code3Param.creditChannel = _this.allParam.creditChannel.channelCode
    },
    // 确认背书
    endorse () {
      this.addLoading();
      this.sendOther({
        url: `/trade-center/cp-discount-order/confirm-endorse/${this.allParam.id}`,
        data: {}
      }, (result) => {
        console.log(result);
        this.getDetail(this.allParam.id)
      })
    },
    // 跳转到订单中心
    toLink () {
      _this.$router.push('/FinishedOrder'); // 路由跳转传递参数
    },

    //======== 步骤 3 start ===========//
    // 查看大图
    imgShow (i, name) {
      const viewer = new Viewer(document.querySelector('.' + name + 'Bg'), {
        title: false,    // 显示图片标题
        tooltip: false,  // 显示缩放比例
        hidden: function () {
          viewer.destroy();
        }
      });

      document.getElementById(name + i).click();
    },

    // 取消订单
    cancelOrderApply () {
      this.addLoading();
      this.sendOther({
        url: `/trade-center/cp-discount-order/apply-cancel/${this.allParam.id}`,
        data: {
          cancelReason: '下单下错了'
        }
      }, (result) => {
        console.log(result);
        this.orderCancelShow = false
        this.getDetail(this.allParam.id)
      })
    },
    // 暂不取消
    cancelOrderConfirm () {
      this.addLoading();
      this.sendOther({
        url: `/trade-center/cp-discount-order/confirm-cancel/${this.allParam.id}`,
        data: {
          status: 'PROCESS',
          cancelReason: '订单终止'
        }
      }, (result) => {
        console.log(result);
        this.orderCancelShow = false
        this.getDetail(this.allParam.id)
      })
    },
    //轮询//
    synchronization () {
      clearTimeout(_this.timer)
      _this.timer = null

      _this.sendGet({
        url: `/trade-center/cp-discount-order/sync/${this.allParam.id}`,
        headers: {
          'Content-Type': "multipart/form-data"
        },
      }, (result) => {
        if (result.data.data.status !== _this.allParam.status || result.data.data.node !== _this.allParam.node) {
          _this.getDetail(this.allParam.id)
        } else if (result.data.data.status === 'CANCEL') {
          // 取消状态下 清除定时器
          clearTimeout(_this.timer)
        } else {
          _this.timer = setTimeout(() => {
            _this.synchronization()
          }, 5000)
        }

      })
    }
  },

}
</script>

<style scoped lang="scss" type="text/css" >
.accountShow {
  /deep/ .ivu-modal-body {
    padding-top: 10px;
  }
  /deep/ .ivu-modal-close {
    .ivu-icon-ios-close {
      color: #e1241a;
      font-weight: 700;
    }
  }
}
.bdr50b {
  border-radius: 50%;
}

.bgF1F5F8 {
  background: #f1f5f8;
}
.cFFD7D5 {
  background: #ffd7d5;
}
.c8785FF {
  color: #8785ff;
}
.bgfff {
  background-color: #fff !important;
}
.disabledStyle {
  background: #e1241aa3 !important;
  color: #fff !important;
}
.ce4231d {
  color: #e4231d;
}
// 流程进度条
.item_logo {
  width: 152px;
  height: 64px;
  margin-right: 50px;
  background: url(~@/assets/img/businessTicketDiscount/dzsp.png) no-repeat
    center top;
  background-size: contain;
  flex: none;
  position: relative;
  top: -8px;
}
/deep/
  .step_style.ivu-steps
  .ivu-steps-item.ivu-steps-status-finish
  .ivu-steps-head-inner {
  background-color: #56adff;
}
/deep/ .ivu-steps-item.ivu-steps-status-process .ivu-steps-head-inner {
  background-color: #56adff;
}
/deep/
  .step_style.ivu-steps
  .ivu-steps-item.ivu-steps-status-process
  .ivu-steps-head:before {
  background-color: #badeff;
}
/deep/ .ivu-steps-item.ivu-steps-status-finish .ivu-steps-tail > i:after {
  background: #56adff;
}

/deep/.ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner span {
  color: #999;
}

// 上传图片背景图
.img_left {
  background: url(~@/assets/img/applicationDiscount/Acceptance_bill_picture@2x.png)
    no-repeat center center;
  background-size: cover;
}
.img_left1 {
  background: url(~@/assets/img/applicationDiscount/BusinessBg@2x.png) no-repeat
    center center;
  background-size: cover;
}

// ====================== code-1 ======================
// 左侧上传票面
.divOcrImg {
  position: relative;
  width: 456px;
  height: 350px;
}
// 右侧票据信息
.right_ticket_img {
  height: 350px;
  padding: 30px 40px 0px;
  background: url(~@/assets/img/businessTicketDiscount/bg_Bill_texture.png)
    no-repeat center center;
  background-size: cover;
}
/* 正在加载中 */
.demo-spin-icon-load-position {
  position: absolute;
  top: 8px;
  left: 56px;
}
// 距离到期日
.dueDayStyle {
  width: 48px;
  // height: 20px;
  line-height: 20px;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #e60012;
  background-color: #fff;
  color: #e60012;
  font-size: 14px;
  position: absolute;
  left: 165px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -mos-transform: translateY(-50%);
  -mz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
// 开始询价
.btnDisable {
  background-color: #e1241a8f !important;
  color: #fff !important;
  border: none !important;
}

.ivu-btn-primary[disabled] {
  background-color: #e1241a8f !important;
  color: #fff !important;
  border: none !important;
}

.ivu-btn[disabled]:hover {
  background-color: #f3271d8f !important;
  color: #fff;
  border: none !important;
}
.btnDiscountBg {
  background-color: #e1241a !important;
  color: #fff !important;
  border: none !important;
}

// ====================== code 2 ======================
/*选择账户*/

table {
  border-collapse: collapse;
  border-spacing: 0;
}
ul li {
  list-style: none;
}
.acctList {
  width: 578px;
  border-radius: 4px;
  border: 1px solid #cccccc;
  border-right: none;
  position: relative;
  margin-right: -2px;
  z-index: 1;

  > ul {
    padding-top: 10px;
    overflow-y: auto;
    width: 577px;

    .ul-list {
      margin-bottom: 10px;
      padding: 0px 8px;
      height: 50px;
      line-height: 50px;

      > div {
        cursor: pointer;
        border: 1px solid #cbcbcb;
        padding-left: 9px;
        border-radius: 4px;
        font-size: 14px;
      }

      &.ul-list-active {
        padding-right: 0;
        font-weight: 700;

        > div {
          border: 1px solid #e95e57;
          border-right-color: #fff7f7;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          background-color: #fff7f7;
        }
      }
    }
  }
}
.acctListDto {
  width: 533px;
  overflow-y: auto;
  position: relative;
  z-index: 0;
  border: 1px solid #e95e57;
  background-color: #fff7f7;
  padding: 12px 12px 0;
  border-radius: 4px;

  li {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 12px;
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
    background-color: #fff;

    > div {
      display: flex;
      flex-direction: row nowrap;
      justify-content: flex-start;

      > p {
        line-height: 14px;
        font-size: 14px;

        &:first-child {
          width: 75px;
        }
      }
    }

    i {
      position: absolute;
      bottom: 0px;
      right: 0px;
      display: inline-block;
      width: 57px;
      height: 33px;
      background: url(~@/assets/img/applicationDiscount/Checked_gray@2x.png)
        no-repeat right bottom;
      background-size: 45px 26px;
    }

    &.active {
      border-color: #e1241a;

      i {
        background: url(~@/assets/img/applicationDiscount/Checked_red@2x.png)
          no-repeat right bottom;
        background-size: 45px 26px;
      }
    }
  }
}
.trialResultList {
  .over-flowH {
    overflow: hidden;
  }
}

.ensureOrder {
  .left {
    .top {
    }
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
}

// ====================== code 3 ======================
/deep/ .ivu-spin-main,
/deep/ .ivu-spin-text {
  width: 100%;
  height: 100%;
}
.documentBg {
  padding-left: 48px;
  padding-right: 32px;

  .documentList {
    margin-bottom: 39px;

    .title {
      > p:first-child {
        position: relative;
        line-height: 20px;
        font-size: 16px;
        margin-bottom: 15px;

        &:before {
          content: '';
          width: 4px;
          height: 16px;
          background-color: #e54038;
          position: absolute;
          left: -11px;
          top: 50%;
          -webkit-transform: translateY(-50%);
          -mos-transform: translateY(-50%);
          -mz-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }

      > p:last-child {
        color: #333;
        line-height: 16px;
        font-size: 14px;
        margin-bottom: 20px;
      }
    }
  }

  .uploadDocumentBg {
    > div {
      width: 227px;
      margin-right: 67px;
      margin-bottom: 20px;

      &:nth-child(4n):not(.uploadOtherStyle),
      &.uploadOtherStyle:nth-child(6n) {
        margin-right: 0px;
      }
    }
    > button {
      width: 227px;
      background-color: #fff;
      border: 1px solid rgba(203, 203, 203, 1);

      i {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(~@/assets/img/businessTicketDiscount/Plus@2x.png)
          no-repeat center center;
        background-size: cover;
      }
    }
  }

  // 合同
  .img_left2 {
    background-color: #f0f7ff;
    width: 129px;
  }

  .iconDocument {
    width: 38px;
    height: 53px;
  }
}
.improveData {
  .tip {
    padding: 2px 6px;
    border-radius: 4px;
    top: 10px;
    cursor: pointer;
    color: #333;
    box-shadow: 0px 2px 5px 0px rgba(194, 194, 194, 0.5);
    &:hover {
      .tip-show {
        display: block;
      }
    }
    .question {
      display: inline-block;
      width: 11px;
      height: 13px;
      background: url(~@/assets/img/businessTicketDiscount/icon_wenti.png);
    }
    .tip-show {
      display: none;
      width: 600px;
      height: 436px;
      position: absolute;
      top: 0;
      right: 100%;
      background: #fff;
      color: #333333;
      font-size: 12px;
      padding: 17px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
      border-radius: 6px 6px 6px 6px;
      &::before {
        width: 0;
        height: 0;
        border: 6px solid #fff;
        content: '';
        border-right-color: transparent;
        border-top-color: transparent;
        border-bottom-color: transparent;
        border-left: 8px solid #fff;
        position: absolute;
        top: 10px;
        right: -14px;
      }
    }
  }
  .no_agreement_upload {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_a.png)
      no-repeat center center;
  }
  .agreement_upload {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/PDF.png) no-repeat
      center center;
  }
  .invoice_bg {
    width: 100%;
    overflow-x: hidden;
    .invoice_upload {
      width: 42px;
      height: 48px;
      background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_b.png)
        no-repeat center center;
    }

    .invoiceAdd {
      width: 42px;
      height: 48px;
      background: url(~@/assets/img/businessTicketDiscount/wenjian_zhuijia.png)
        no-repeat center center;
      background-size: contain;
    }
    .invoice_btn {
      display: inline-block;
      width: 60px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      border: 1px solid #cbcbcb;
      cursor: pointer;
    }
    .agreement_upload_btn {
      display: inline-block;
      height: 30px;
      width: 60px;
      line-height: 30px;
      border-radius: 4px;
      border: 1px solid #cbcbcb;
      cursor: pointer;
    }
  }

  .imgUploadBg {
    height: 30px;
    width: 60px;
    // border-radius: 4px;
    // border: 1px solid #cbcbcb;
  }
}

.kapian {
  width: 398px;
  height: 236px;
  text-align: left;
  color: #ffff;
  .title {
    display: inline-block;
    width: 80px;
  }
}
.kapian_a {
  background: url(~@/assets/img/businessTicketDiscount/kapian_a.png) no-repeat
    center center;
  background-size: cover;
}
.kapian_b {
  background: url(~@/assets/img/businessTicketDiscount/kapian_b.png) no-repeat
    center center;
  background-size: cover;
}
.icon_Copy {
  display: inline-block;
  width: 12.13px;
  height: 12.13px;
  background: url(~@/assets/img/businessTicketDiscount/icon_fz.png) no-repeat
    center center;
  background-size: cover;
}
.icon_Clock {
  display: inline-block;
  width: 32px;
  height: 32px;
  background: url(~@/assets/img/businessTicketDiscount/icon_time.png) no-repeat
    center center;
  background-size: cover;
}
.icon_hkcg {
  display: inline-block;
  width: 32px;
  height: 32px;
  background: url(~@/assets/img/businessTicketDiscount/icon_hkcg.png) no-repeat
    center center;
  background-size: cover;
}

.icon-await {
  display: inline-block;
  width: 82px;
  height: 82px;
  background: url(~@/assets/img/businessTicketDiscount/ICON_SHZ.png) no-repeat
    center center;
  background-size: cover;
}
.icon-fail {
  display: inline-block;
  width: 82px;
  height: 82px;
  background: url(~@/assets/img/businessTicketDiscount/ICON_ddslsb.png)
    no-repeat center center;
  background-size: cover;
}
.icon-quxiao {
  display: inline-block;
  width: 82px;
  height: 82px;
  background: url(~@/assets/img/businessTicketDiscount/icon_quxiao.png)
    no-repeat center center;
  background-size: cover;
}
.icon-quxiao-chenggong {
  display: inline-block;
  width: 82px;
  height: 82px;
  background: url(~@/assets/img/businessTicketDiscount/icon_xiadanchenggong.png)
    no-repeat center center;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/businessTicketDiscount/BusinessTicketDiscount.vue